// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2BlFL","rootSuccess":"CompleteLink_rootSuccess__1DW2m","rootFailure":"CompleteLink_rootFailure__1TDdW","isDisabled":"CompleteLink_isDisabled__1cVS7"};